import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ThumbsUp, MessageCircle, Share2, MoreHorizontal, Globe, Heart } from 'lucide-react';
import { CTAButton } from './CTAButton';
const testimonials = [{
  name: 'Daniel P.',
  location: 'Bogotá, CO',
  time: 'Hace 5 días',
  image: 'https://randomuser.me/api/portraits/men/45.jpg',
  title: '"Planos Fáciles de Leer, a Diferencia de Otros..."',
  text: <>
        Recibí el paquete hace pocos días y no he podido dejar de revisarlo. Los
        esquemas a color con medidas exactas hacen que{' '}
        <span className="font-bold bg-yellow-100 px-1" data-id="element-345">
          todo sea clarísimo.
        </span>{' '}
        A diferencia de otros planos que compré antes, estos realmente puedo
        entenderlos. Ya tengo 3 proyectos seleccionados para empezar esta
        semana.
      </>,
  likes: 89,
  comments: 8,
  shares: 1
}, {
  name: 'Miguel Á.',
  location: 'Lima, PE',
  time: 'Hace 1 semana',
  image: 'https://randomuser.me/api/portraits/men/22.jpg',
  title: '"Una Inversión Excelente Para Quien Empieza"',
  text: <>
        De todos los materiales que he comprado a lo largo de los años, esta es
        la mejor colección que tengo. Recurso excelente para principiantes y
        para herreros con experiencia. Incluye planos para muebles chicos,
        grandes, equipamiento de gym... Considerando la calidad y la cantidad,{' '}
        <span className="font-bold bg-yellow-100 px-1" data-id="element-346">
          es una ganga absoluta.
        </span>
      </>,
  likes: 215,
  comments: 24,
  shares: 15
}, {
  name: 'Carlos R.',
  location: 'Santiago, CL',
  time: 'Hace 3 días',
  image: 'https://randomuser.me/api/portraits/men/67.jpg',
  title: '"Me Habían Quemado Antes, Pero Esto Me Demostró Lo Contrario..."',
  text: <>
        Ya me habían estafado con cursos que prometen mucho y no enseñan nada
        práctico. Pero este paquete me demostró que estaba equivocado.{' '}
        <span className="font-bold bg-yellow-100 px-1" data-id="element-347">
          Para un principiante, esto es un regalo del cielo:
        </span>{' '}
        cada detalle que necesitás, las herramientas, el proceso completo
        explicado. Si querés fabricar piezas de calidad, te debés a vos mismo
        conseguir este sistema.
      </>,
  likes: 156,
  comments: 18,
  shares: 7
}];
export function TestimonialGrid() {
  return <section className="py-12 px-4 bg-[#111]" data-id="element-348">
      <div className="max-w-7xl mx-auto" data-id="element-349">
        <div className="text-center mb-10" data-id="element-350">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-2" data-id="element-351">
            ESCUCHÁ LO QUE DICEN{' '}
            <span className="text-[#FF6B00]" data-id="element-352">NUESTROS CLIENTES</span>
          </h2>

          <p className="text-gray-300 text-base max-w-2xl mx-auto mt-4" data-id="element-353">
            Los comentarios de nuestra comunidad en Facebook
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-354">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-355">
              {/* Header */}
              <div className="p-4 flex items-start justify-between" data-id="element-356">
                <div className="flex gap-3" data-id="element-357">
                  <img src={t.image} alt={t.name} className="w-10 h-10 rounded-full object-cover border border-gray-200" width={40} height={40} loading="lazy" decoding="async" data-id="element-358" />
                  <div data-id="element-359">
                    <h3 className="font-bold text-gray-900 text-sm leading-tight" data-id="element-360">
                      {t.name}
                    </h3>
                    <div className="flex items-center gap-1 text-xs text-gray-500 mt-0.5" data-id="element-361">
                      <span data-id="element-362">{t.time}</span>
                      <span data-id="element-363">·</span>
                      <span data-id="element-364">{t.location}</span>
                      <span data-id="element-365">·</span>
                      <Globe className="w-3 h-3" data-id="element-366" />
                    </div>
                  </div>
                </div>
                <button className="text-gray-500 hover:bg-gray-100 p-1 rounded-full" aria-label="Más opciones" data-id="element-367">
                  <MoreHorizontal className="w-5 h-5" data-id="element-368" />
                </button>
              </div>

              {/* Content */}
              <div className="px-4 pb-2" data-id="element-369">
                <p className="text-gray-900 font-medium mb-2 text-base" data-id="element-370">
                  {t.title}
                </p>
                <p className="text-gray-800 text-sm leading-relaxed mb-3" data-id="element-371">
                  {t.text}
                </p>
              </div>

              {/* Stats Row */}
              <div className="px-4 py-2 flex items-center justify-between text-xs text-gray-500 border-b border-gray-100" data-id="element-372">
                <div className="flex items-center gap-1" data-id="element-373">
                  <div className="flex -space-x-1" data-id="element-374">
                    <div className="w-4 h-4 bg-[#1877F2] rounded-full flex items-center justify-center border border-white z-10" data-id="element-375">
                      <ThumbsUp className="w-2.5 h-2.5 text-white fill-current" data-id="element-376" />
                    </div>
                    <div className="w-4 h-4 bg-[#F02849] rounded-full flex items-center justify-center border border-white" data-id="element-377">
                      <Heart className="w-2.5 h-2.5 text-white fill-current" data-id="element-378" />
                    </div>
                  </div>
                  <span className="hover:underline cursor-pointer" data-id="element-379">
                    {t.likes}
                  </span>
                </div>
                <div className="flex gap-3" data-id="element-380">
                  <span className="hover:underline cursor-pointer" data-id="element-381">
                    {t.comments} comentarios
                  </span>
                  <span className="hover:underline cursor-pointer" data-id="element-382">
                    {t.shares} veces compartido
                  </span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="px-2 py-1 flex items-center justify-between" data-id="element-383">
                <button className="flex-1 flex items-center justify-center gap-2 py-2 hover:bg-gray-50 rounded-lg text-gray-600 font-medium text-sm transition-colors" data-id="element-384">
                  <ThumbsUp className="w-5 h-5" data-id="element-385" />
                  <span data-id="element-386">Me gusta</span>
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 py-2 hover:bg-gray-50 rounded-lg text-gray-600 font-medium text-sm transition-colors" data-id="element-387">
                  <MessageCircle className="w-5 h-5" data-id="element-388" />
                  <span data-id="element-389">Comentar</span>
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 py-2 hover:bg-gray-50 rounded-lg text-gray-600 font-medium text-sm transition-colors" data-id="element-390">
                  <Share2 className="w-5 h-5" data-id="element-391" />
                  <span data-id="element-392">Compartir</span>
                </button>
              </div>
            </motion.div>)}
        </div>

        {/* CTA below testimonials */}
        <div className="flex flex-col items-center text-center mt-12" data-id="element-393">
          <CTAButton size="xl" className="w-full md:w-auto mb-2 text-sm md:text-xl shadow-xl" href="https://carlosponte.com/cart/add?id=56937498575173&quantity=1" data-id="element-394">
            QUIERO MIS PLANOS
          </CTAButton>
          <p className="text-sm text-gray-500 mb-1 font-medium" data-id="element-395">
            Acceso Inmediato a +600 Planos + 8 Bonos &gt;&gt;
          </p>
          <p className="text-xs text-gray-400" data-id="element-396">
            Pago único. Sin cargos mensuales.
          </p>
        </div>
      </div>
    </section>;
}